import { Firebase } from '@linktivity/link-utils';
import { config as env } from '@triplabo/web/utils/env';

const webAuth = new Firebase({
  apiKey: env.firebaseApiKey,
  authDomain: env.firebaseAuthDomain
});

if (env.firebaseTenantId) {
  webAuth.setTenantId(env.firebaseTenantId);
}

export default webAuth;
